import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL || ''
const instance = axios.create({ baseURL })

instance.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('personal')
    const personal = raw ? JSON.parse(raw) : null
    if (personal && personal.clientToken) {
      if (!config.headers) config.headers = {}
      if (typeof config.headers.set === 'function') {
        config.headers.set('X-Client-Token', personal.clientToken)
      } else {
        config.headers['X-Client-Token'] = personal.clientToken
      }
    }
  } catch (e) {
    // ignore parse/access errors for personal
  }
  return config
})

/**
 * Pemanggilan API: api(path, { method: 'GET' | 'POST', ... })
 * @example
 * const res = await api(`/products/${id}`, { method: 'GET' })
 * const data = res.data
 */
export async function api(path, options = {}) {
  const res = await instance({ url: path, ...options })
  return res
}

export const apiRoutes = {
  products: '/products',
  /** Backend tidak punya /productsBest — fallback ke /products */
  productsBest: '/products',
  productsCari: (q) => `/products/search?name=${encodeURIComponent(q)}`,
  productsDetail: (id) => `/products/${id}/detail`,
  clientByToken: (token) => `/clients/${encodeURIComponent(token)}`,
}

/**
 * Normalizes GET /products/:id/detail (flat JSON atau wrapper Laravel { data: { ... } }).
 */
export function normalizeProductDetailResponse(res) {
  const raw = res && res.data
  if (raw == null) return {}
  if (typeof raw === 'string') return {}
  if (typeof raw !== 'object' || Array.isArray(raw)) return {}
  const nested = raw.data
  if (
    nested != null &&
    typeof nested === 'object' &&
    !Array.isArray(nested) &&
    ('id' in nested || 'nama' in nested || 'harga' in nested || 'gambar' in nested)
  ) {
    return nested
  }
  return raw
}
